import React from 'react';
import { X, Image as ImageIcon, Info } from 'lucide-react';

interface PasiInfoModalProps {
  type: 'redness' | 'thickness' | 'scale';
  onClose: () => void;
}

export default function PasiInfoModal({ type, onClose }: PasiInfoModalProps) {
  const infoData = {
    redness: { title: 'Grading Redness (Erythema)', img: 'pasi-redness.png' },
    thickness: { title: 'Grading Thickness (Induration)', img: 'pasi-thickness.png' },
    scale: { title: 'Grading Scale (Desquamation)', img: 'pasi-scale.png' },
  };

  const currentInfo = infoData[type];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm animate-fade-in">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-lg max-h-[90vh] flex flex-col overflow-hidden animate-slide-up">
        {/* Header */}
        <div className="px-6 py-4 border-b border-slate-100 flex items-center justify-between sticky top-0 bg-white z-10">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-blue-50 flex items-center justify-center text-blue-500">
              <Info className="w-5 h-5" />
            </div>
            <h2 className="text-lg font-bold text-slate-800">{currentInfo.title}</h2>
          </div>
          <button
            onClick={onClose}
            className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-4 md:p-6 flex flex-col items-center">
          <div className="bg-slate-50 rounded-xl border-2 border-dashed border-slate-300 w-full flex flex-col items-center justify-center relative">
            <img 
              src={`/${currentInfo.img}?v=2`} 
              alt={currentInfo.title}
              className="max-w-full max-h-[75vh] object-contain rounded-lg"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
                target.parentElement?.classList.add('min-h-[300px]', 'p-6');
                target.nextElementSibling?.classList.remove('hidden');
              }}
            />
            <div className="hidden flex-col items-center text-center text-slate-400 w-full p-4">
              <ImageIcon className="w-12 h-12 mb-3 text-slate-300" />
              <p className="font-medium text-slate-500 mb-2">Image not found</p>
              <p className="text-sm">Please save the screenshot from the website for <strong>{type}</strong> as:</p>
              <code className="bg-slate-200 px-2 py-1 rounded text-slate-700 mt-2 block w-max mx-auto">
                public/{currentInfo.img}
              </code>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}